module.exports = __webpack_public_path__ + "static/img/4.a62219c7.jpg";